export default __webpack_public_path__ + "static/media/baby-12.31189993.svg";